// ARCHIVO COMPARTIDO app/web — editar en ambos repos. Verificar con `npm run check:shared` (TemControlApp).
//
// Provincias de España y su comunidad autónoma. El nombre de la comunidad
// se resuelve contra el listado del backend (/api/holiday/spain/acList)
// para obtener el id que se pasa a /api/holiday/spain/{id}/{year}.

export const PROVINCES = [
  { name: 'Álava',                  community: 'País Vasco' },
  { name: 'Albacete',               community: 'Castilla-La Mancha' },
  { name: 'Alicante',               community: 'Comunidad Valenciana' },
  { name: 'Almería',                community: 'Andalucía' },
  { name: 'Asturias',               community: 'Principado de Asturias' },
  { name: 'Ávila',                  community: 'Castilla y León' },
  { name: 'Badajoz',                community: 'Extremadura' },
  { name: 'Barcelona',              community: 'Cataluña' },
  { name: 'Burgos',                 community: 'Castilla y León' },
  { name: 'Cáceres',                community: 'Extremadura' },
  { name: 'Cádiz',                  community: 'Andalucía' },
  { name: 'Cantabria',              community: 'Cantabria' },
  { name: 'Castellón',              community: 'Comunidad Valenciana' },
  { name: 'Ceuta',                  community: 'Ceuta' },
  { name: 'Ciudad Real',            community: 'Castilla-La Mancha' },
  { name: 'Córdoba',                community: 'Andalucía' },
  { name: 'A Coruña',               community: 'Galicia' },
  { name: 'Cuenca',                 community: 'Castilla-La Mancha' },
  { name: 'Girona',                 community: 'Cataluña' },
  { name: 'Granada',                community: 'Andalucía' },
  { name: 'Guadalajara',            community: 'Castilla-La Mancha' },
  { name: 'Gipuzkoa',               community: 'País Vasco' },
  { name: 'Huelva',                 community: 'Andalucía' },
  { name: 'Huesca',                 community: 'Aragón' },
  { name: 'Illes Balears',          community: 'Islas Baleares' },
  { name: 'Jaén',                   community: 'Andalucía' },
  { name: 'León',                   community: 'Castilla y León' },
  { name: 'Lleida',                 community: 'Cataluña' },
  { name: 'Lugo',                   community: 'Galicia' },
  { name: 'Madrid',                 community: 'Comunidad de Madrid' },
  { name: 'Málaga',                 community: 'Andalucía' },
  { name: 'Melilla',                community: 'Melilla' },
  { name: 'Murcia',                 community: 'Región de Murcia' },
  { name: 'Navarra',                community: 'Comunidad Foral de Navarra' },
  { name: 'Ourense',                community: 'Galicia' },
  { name: 'Palencia',               community: 'Castilla y León' },
  { name: 'Las Palmas',             community: 'Canarias' },
  { name: 'Pontevedra',             community: 'Galicia' },
  { name: 'La Rioja',               community: 'La Rioja' },
  { name: 'Salamanca',              community: 'Castilla y León' },
  { name: 'Santa Cruz de Tenerife', community: 'Canarias' },
  { name: 'Segovia',                community: 'Castilla y León' },
  { name: 'Sevilla',                community: 'Andalucía' },
  { name: 'Soria',                  community: 'Castilla y León' },
  { name: 'Tarragona',              community: 'Cataluña' },
  { name: 'Teruel',                 community: 'Aragón' },
  { name: 'Toledo',                 community: 'Castilla-La Mancha' },
  { name: 'Valencia',               community: 'Comunidad Valenciana' },
  { name: 'Valladolid',             community: 'Castilla y León' },
  { name: 'Bizkaia',                community: 'País Vasco' },
  { name: 'Zamora',                 community: 'Castilla y León' },
  { name: 'Zaragoza',               community: 'Aragón' },
];

const normalize = (s = '') =>
  String(s || '').normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();

export const communityForProvince = (provinceName) => {
  const p = PROVINCES.find((x) => normalize(x.name) === normalize(provinceName));
  return p ? p.community : null;
};

// Busca el id de comunidad en la lista devuelta por el backend (localList),
// emparejando por nombre normalizado. Retorna null si no se encuentra.
export const resolveCommunityId = (provinceName, backendList) => {
  const cName = communityForProvince(provinceName);
  if (!cName || !Array.isArray(backendList)) return null;
  const target = normalize(cName);
  const match = backendList.find((c) => {
    const n = normalize(c.name || '');
    return n === target || n.includes(target) || target.includes(n);
  });
  return match ? match.id : null;
};
